import { useState } from 'react';
import { toast } from 'sonner';
import { Check, Compass } from 'lucide-react';
import { useAuthStore } from '@/stores/auth.store';
import { useChangePassword } from './settings.api';
import { useProductTour } from '@/features/onboarding/useProductTour';

export function AccountTab(): JSX.Element {
  const user = useAuthStore((s) => s.user);
  const change = useChangePassword();
  const tour = useProductTour();
  const [f, setF] = useState({ current: '', next: '', confirm: '' });

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (f.next.length < 8) return toast.error('La nueva contraseña debe tener al menos 8 caracteres');
    if (f.next !== f.confirm) return toast.error('Las contraseñas no coinciden');
    change.mutate({ currentPassword: f.current, newPassword: f.next }, { onSuccess: () => setF({ current: '', next: '', confirm: '' }) });
  };

  return (
    <div className="cx">
      <form className="card" style={{ maxWidth: 560 }} onSubmit={submit}>
        <div className="card-head">
          <div className="card-title">Mi cuenta</div>
        </div>
        <div className="card-pad col gap14">
          <div className="field">
            <label className="label">Nombre</label>
            <input className="input" value={user?.name ?? ''} disabled />
          </div>
          <div className="field">
            <label className="label">Correo</label>
            <input className="input" value={user?.email ?? ''} disabled />
          </div>

          <div className="divider" style={{ margin: '6px 0' }} />
          <div className="t-h2 fw7">Cambiar contraseña</div>

          <div className="field">
            <label className="label">Contraseña actual</label>
            <input
              className="input"
              type="password"
              placeholder="••••••••"
              autoComplete="current-password"
              value={f.current}
              onChange={(e) => setF((s) => ({ ...s, current: e.target.value }))}
              required
            />
          </div>
          <div className="grid" style={{ gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div className="field">
              <label className="label">Nueva contraseña</label>
              <input
                className="input"
                type="password"
                placeholder="••••••••"
                autoComplete="new-password"
                minLength={8}
                value={f.next}
                onChange={(e) => setF((s) => ({ ...s, next: e.target.value }))}
                required
              />
            </div>
            <div className="field">
              <label className="label">Confirmar</label>
              <input
                className="input"
                type="password"
                placeholder="••••••••"
                autoComplete="new-password"
                value={f.confirm}
                onChange={(e) => setF((s) => ({ ...s, confirm: e.target.value }))}
                required
              />
            </div>
          </div>
          <div className="row" style={{ marginTop: 6 }}>
            <button type="submit" className="btn btn-primary mla" disabled={change.isPending}>
              <Check size={17} />
              {change.isPending ? 'Guardando…' : 'Actualizar'}
            </button>
          </div>
        </div>
      </form>

      <div className="card" style={{ maxWidth: 560, marginTop: 16 }}>
        <div className="card-head">
          <div className="card-title">Recorrido del sistema</div>
        </div>
        <div className="card-pad row between aic gap14">
          <p className="muted t-sm" style={{ margin: 0 }}>
            ¿Quieres repasar las secciones principales de Cajita? Vuelve a ver el recorrido guiado.
          </p>
          <button type="button" className="btn btn-secondary" onClick={tour.start}>
            <Compass size={17} />
            Ver recorrido
          </button>
        </div>
      </div>
    </div>
  );
}
